import(/* webpackMode: "eager" */ "/vercel/path0/src/app/foreign-investment-services-page/page.tsx");
